import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import { type FC, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const SortTypes = {
	default: "default",
	producer: "producer",
	date: "date",
} as const;

export type SortKey = keyof typeof SortTypes;

type Props = {
	activeSort: keyof typeof SortTypes;
	setSort: (val: keyof typeof SortTypes) => void;
};

type SortItem = {
	value: (typeof SortTypes)[keyof typeof SortTypes];
	checked: boolean;
};

export const SortDrawer: FC<Props> = ({ activeSort, setSort }) => {
	const { t } = useResource();
	const theme = useTheme();

	const initialSorterItems: SortItem[] = Object.values(SortTypes).map(
		(value) => ({
			value,
			checked: value === activeSort,
		}),
	);
	const [sorter, setSorter] = useState<SortItem[]>(initialSorterItems);

	const setActiveSorter = (index: number) => {
		const newValue = sorter[index].value as SortKey;
		setSorter((prev) =>
			prev.map((item, itemIndex) => ({
				value: item.value,
				checked: itemIndex === index,
			})),
		);

		setSort(newValue);
	};

	return (
		<Stack pb={1.6}>
			{sorter.map((s, index) => (
				<Stack
					key={s.value}
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					onClick={() => setActiveSorter(index)}
					px={1.6}
				>
					<Typography>
						{t(Resources.Portfolio.List.Sorter.Types[s.value])}
					</Typography>
					<IconButton>
						<Check
							size={theme.iconSize.sm}
							color={theme.palette.primary.main}
							style={{
								visibility: s.checked ? "visible" : "hidden",
							}}
						/>
					</IconButton>
				</Stack>
			))}
		</Stack>
	);
};
